import { render, staticRenderFns } from "./SelectButtonGroup.vue?vue&type=template&id=11524f6c&"
import script from "./SelectButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./SelectButtonGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports